function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}.cls-6{clip-path:url(#clip-path-4);}.cls-7{clip-path:url(#clip-path-5);}.cls-8{clip-path:url(#clip-path-6);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "20.89 51.13 20.89 51.13 69.04 51.13 69.04 59.69 20.89 59.69 20.89 51.13"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "57.21 51.13 57.21 51.13 69.04 51.13 69.04 59.69 57.21 59.69 57.21 51.13"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "32.71 51.13 32.71 51.13 20.89 51.13 20.89 59.69 32.71 59.69 32.71 51.13"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "20.89 38.88 20.89 38.88 69.04 38.88 69.04 30.32 20.89 30.32 20.89 38.88"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "57.21 38.88 57.21 38.88 69.04 38.88 69.04 30.32 57.21 30.32 57.21 38.88"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6",
  transform: "translate(-4.69)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "32.71 38.88 32.71 38.88 20.89 38.88 20.89 30.32 32.71 30.32 32.71 38.88"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M37.93,87.07a10,10,0,1,0,0-14.14A10,10,0,0,0,37.93,87.07Zm12-12a7,7,0,1,1-9.9,0A7,7,0,0,1,50,75.05Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_2",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5,59.91a10,10,0,1,0,12.25-7.07A10,10,0,0,0,5,59.91Zm16.42,4.4a7,7,0,1,1-4.95-8.57A7,7,0,0,1,21.45,64.31Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_3",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M12.1,17.84a10,10,0,1,0,12.25,7.07A10,10,0,0,0,12.1,17.84Zm4.4,16.42a7,7,0,1,1,4.95-8.57A7,7,0,0,1,16.5,34.26Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_4",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M52.07,2.93a10,10,0,1,0,0,14.14A10,10,0,0,0,52.07,2.93Zm-12,12A7,7,0,1,1,50,15,7,7,0,0,1,40.05,15Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_5",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M85,30.09a10,10,0,1,0-12.25,7.07A10,10,0,0,0,85,30.09Zm-16.42-4.4a7,7,0,1,1,5,8.57A7,7,0,0,1,68.55,25.69Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Radial_Repeat_6",
  "data-name": "<Radial Repeat>"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M77.9,72.16a10,10,0,1,0-12.25-7.07A10,10,0,0,0,77.9,72.16ZM73.5,55.74a7,7,0,1,1-5,8.57A7,7,0,0,1,73.5,55.74Z",
  transform: "translate(-4.69)"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_2",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-4"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 57.16,
  y: 53.91,
  width: 11.92,
  height: 3,
  transform: "matrix(0.87, 0.5, -0.5, 0.87, 31.48, -24.14)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_3",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 20.84,
  y: 53.91,
  width: 11.92,
  height: 3,
  transform: "translate(73.03 90.01) rotate(150)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_4",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-6"
}, /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_5",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-7"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 57.16,
  y: 33.1,
  width: 11.92,
  height: 3,
  transform: "translate(-13.53 36.2) rotate(-30)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_Mirror_Repeat_6",
  "data-name": "<Mirror Repeat>"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-8"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 20.84,
  y: 33.1,
  width: 11.92,
  height: 3,
  transform: "translate(28.02 77.96) rotate(-150)"
}))))), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M57.37,32.63A17.37,17.37,0,0,0,46.5,27.57V17.89h-3v9.68a17.5,17.5,0,0,0,0,34.86v9.7h3v-9.7a17.49,17.49,0,0,0,10.91-29.8ZM55.25,55.25a14.5,14.5,0,1,1,0-20.5A14.5,14.5,0,0,1,55.25,55.25Z",
  transform: "translate(-4.69)"
})));

function SvgAffiliateDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80.63 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateDark);
export default __webpack_public_path__ + "static/media/affiliate-dark.b98d504a.svg";
export { ForwardRef as ReactComponent };